import React from "react";

const skillsContent = [
  { skillClass: "p90", skillPercent: "90", skillName: "Business Acumen" },
  { skillClass: "p89", skillPercent: "89", skillName: "Project Management" },
  { skillClass: "p95", skillPercent: "95", skillName: "Strategic Planning" },
  { skillClass: "p96", skillPercent: "96", skillName: "Digital Marketing" },
  { skillClass: "p90", skillPercent: "90", skillName: "Legal Expertise" },
  { skillClass: "p93", skillPercent: "93", skillName: "Client Relations" },
  { skillClass: "p97", skillPercent: "97", skillName: "Technical Proficiency" },
  { skillClass: "p92", skillPercent: "92", skillName: "Team Leadership" },
];

const Ski = () => {
  return (
    <>
      {skillsContent.map((val, i) => (
        <div className="col-6 col-md-3 mb-3 mb-sm-5" key={i}>
          <div className={`c100 ${val.skillClass}`}>
            <span>{val.skillPercent}%</span>
            <div className="slice">
              <div className="bar"></div>
              <div className="fill"></div>
            </div>
          </div>
          <h6 className="text-uppercase open-sans-font text-center mt-2 mt-sm-4">
            {val.skillName}
          </h6>
        </div>
      ))}
    </>
  );
};

export default Ski;
